import { useEffect, useState, useContext, useRef} from 'react'
import { useNavigate, Link } from "react-router-dom";

import { MdClose } from "react-icons/md";

import { AppContext } from "../../Context";
import Fetch, { Loader, dateToText } from "../inc/Fetch";
import { Img, Tasks } from "./Elements";

import './css/popup.css'

export default function Popup({ children, effect, style, className }) {
	
	let navigate = useNavigate();
	const [show, setshow] = useState(false)

	if (!effect) {
		effect = "zoom";
	}

	function clickClose(e) {
		
		if (typeof e?.target?.className?.baseVal =='undefined' && e?.target?.className?.indexOf('popupBlack') > -1) {
			navigate(-1);
		}

	}

	useEffect(() => {
		setTimeout(() => {
			setshow(true);
		}, 1);
	}, []);
	

	return (
		<>
			<div  className={`popupBlack ${effect} ${className}`}>
				<div className={`popupBox ${show && 'open'}`} style={style}>
					<a className='close' onClick={() => navigate(-1)}><MdClose /></a>
					{children}
				</div>
			</div>
			
		</>
	)
}
